import { createSlice } from '@reduxjs/toolkit';

interface OrganizationState {
  id: string;
  name: string;
}

const initialState: OrganizationState = {
  id: '',
  name: '',
};

const organizationSlice = createSlice({
  name: 'organization',
  initialState,
  reducers: {
    setOrganization: (state, action) => {
      state.id = action.payload.id;
      state.name = action.payload.name;
    },
    clearOrganization: state => {
      state.id = '';
      state.name = '';
    },
  },
});

export const { setOrganization, clearOrganization } = organizationSlice.actions;
export default organizationSlice.reducer;
